<template>
  <v-sheet height="56">
    <v-toolbar flat fixed :style="headerStyle">
      <v-btn fab text x-small color="black" @click="$emit('clickClose')">
        <v-icon size="24"> mdi-close </v-icon>
      </v-btn>
      <!-- 태그를 지우면 가운데 제목이 우측으로 이동 -->
      <v-toolbar-title
        class="bold"
        @click="$emit('clickSave')"
        v-if="headerSaveBtn"
      >
        {{ headerSaveBtn }}
      </v-toolbar-title>
    </v-toolbar>
  </v-sheet>
</template>

<script>
/* modal header */

export default {
  props: {
    // 저장버튼명
    headerSaveBtn: {
      type: String,
      default: '',
    },
    headerBg: {
      type: String,
      default: 'white',
    },
  },
  computed: {
    headerStyle() {
      if (this.headerBg === 'grey') {
        return `background-color: #f5f6f7`;
      } else if (this.headerBg === '') {
        return `background-color: #fffff`;
      } else {
        return `background-color: ${this.headerBg}`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.bg-grey {
  background-color: #f5f6f7;
}
</style>
